var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReassign(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09 6.552C8.489 6.552 8 6.081 8 5.5c0-.582.488-1.053 1.09-1.053h6.22l-1.68-1.622c-.447-.433-.465-1.116-.04-1.527.426-.412 1.133-.395 1.581.037l3.449 3.332a.25.25 0 01.02.024c.006.008.012.016.02.023l.018.014a.295.295 0 01.017.013c.426.412.403 1.1-.052 1.538l-3.495 3.378c-.454.438-1.166.46-1.592.05-.425-.412-.402-1.1.051-1.539l1.674-1.617-6.191.001zm-.87 6.115A3.095 3.095 0 114.783 7.52a3.095 3.095 0 013.437 5.147zm-.154 1.208H9.25a2.75 2.75 0 012.75 2.75v.344A1.032 1.032 0 0110.97 18H2.031A1.032 1.032 0 011 16.968v-.343a2.75 2.75 0 012.75-2.75h1.184a3.74 3.74 0 003.132 0z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default ForwardRef;